import { z } from 'zod';

import { userSchema } from '../../../shared/source/data-contract/user';

export const assignableJobProfileReviewer = userSchema.pick({
    id: true,
    emailAddress: true,
    firstName: true,
    lastName: true,
});

export type AssignableJobProfileReviewer = z.infer<typeof assignableJobProfileReviewer>;

export const jobProfileReviewerCandidateSchema = z.object({
    id: z.string(),
    emailAddress: z.string().optional(),
    firstName: z.string(),
    lastName: z.string(),
});

export type JobProfileReviewerCandidate = z.infer<typeof jobProfileReviewerCandidateSchema>;

export const jobProfileReviewerCandidatesSchema = jobProfileReviewerCandidateSchema.array();

export type JobProfileReviewerCandidates = z.infer<typeof jobProfileReviewerCandidatesSchema>;
